export const RESTAURANT = 'restaurant';
export const JOB = 'job';
